export const environment = {
  production: false,
  name: 'Dev',
  // API: 'https://localhost:44328/api',
  API: 'https://parceirousbff.api.hml.pjus.com.br/api',
  V1: 'v1',
  CLARITY: 'ruqcoq53tm',
  licenseKey: 'NRJS-82f7743c7a343504d2e',
  applicationID: '1103417858',
  accountID: '4504660',
  trustKey: '4504660',
  agentID: '1103417858',
  maxFileSize: 200 * 1024 * 1024,
  tamanhoMaximoDefinido: '200 MB',
  rotaCotacao: 'area-parceiro',
  uploadDiretoS3: true,
  awsS3: {
    region: 'sa-east-1',
    bucket: 'pjus-hml-files',
    prefixo: 'us/esteira',
    cognitoIdentityPoolId: '', // ex.: sa-east-1:xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
    cognitoProviderName: '',     // domínio do IdP federado (ex.: cognito-idp.../login.microsoftonline.com/<tenant>),
    ChaveS3: "AKIA5SVOTKL3M7WT6JVW",
    ChaveSecretaS3: "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",
  }
};
